var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:(_vm.intersectConfig),expression:"intersectConfig"}],staticClass:"infinite-spinner"},[_c('spinner',{attrs:{"active":"","inline":"","small":""}}),_c('div',[_vm._v("Loading additional records...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }